<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          Fly Gate
        </b-card>
      </b-col>
    </b-row>
    <div id="paymentsDiv">
      <b-row>
        <b-col md="1" />
        <b-col md="8">
          <b-card>
            <b-card-body>
              <h3>Select Payment Option</h3>
              <b-row>
                <b-col
                  v-for="(item, index) in paymentOptions"
                  :key="index"
                  md="3"
                >
                  <b-link @click="handelSelect(item)">
                    <b-card :border-variant="item.bv" :bg-variant="item.bg">
                      <feather-icon v-if="item.visible" icon="CheckIcon" />
                      <b-avatar class="pull-up" :src="item.logo" size="70px" />
                      <!-- <b-img
                            left
                            class="mb-1 mb-sm-0"
                            height="120"
                            :src="item.log"
                            alt="Left image')"
                          /> -->
                      {{ item.name }}
                    </b-card>
                  </b-link>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-footer>
              <b-col align-self="center">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="SubmitData()"
                >
                  <feather-icon icon="SaveIcon" class="mr-25" />
                  <span>Pay</span>
                </b-button>
              </b-col>
            </b-card-footer>
          </b-card>
        </b-col>
        <b-col md="2">
          <b-card>
            <b-list-group flush>
              <b-list-group-item href="#">
                Order Id: <strong>{{ customerData.orderId }}</strong>
              </b-list-group-item>
              <b-list-group-item href="#">
                First Name: <strong>{{ customerData.firstName }}</strong>
              </b-list-group-item>
              <b-list-group-item href="#">
                Last Name: <strong>{{ customerData.lastName }}</strong>
              </b-list-group-item>
              <b-list-group-item href="#">
                Ammount: <strong>{{ customerData.ammount }}</strong>
              </b-list-group-item>
              <b-list-group-item href="#">
                Currency: <strong>{{ customerData.currency }}</strong>
              </b-list-group-item>
              <b-list-group-item href="#">
                Selected Payment Option:
                <strong>{{ selectedPaymentOption }}</strong>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div v-if="toogle">
      <div>
        <b-row>
          <b-col md="1" />
          <b-col md="7">
            <h3>Payment Instructions</h3>
            <br />
            <b-card>
              <ul class="list-group list-group-flush">
                <li
                  v-for="value in instructions"
                  :key="value"
                  class="list-group-item"
                >
                  <feather-icon color="success" icon="CheckCircleIcon" />
                  {{ value.description }}
                </li>
              </ul>
            </b-card>
          </b-col>

          <b-col md="3">
            <br />
            <br />
            <b-card>
              <b-list-group flush>
                <b-list-group-item href="#">
                  Payment Option: <strong>{{ paymentOptionName }}</strong>
                </b-list-group-item>

                <b-list-group-item href="#">
                  Order Id: <strong>{{ orderId }}</strong>
                </b-list-group-item>
                <b-list-group-item href="#">
                  Amount: <strong>{{ returnedAmount }}</strong>
                </b-list-group-item>

                <b-list-group-item href="#">
                  <h3>Expiry date :{{ expiryDate }}</h3>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-col>

          <b-col md="1" />
        </b-row>
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </div>
    </div>
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>
<script>
import {
  BLink,
  BRow,
  BCol,
  BCard,
  BAvatar,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BButton,
  BCardFooter,
  BOverlay,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import axios from "@axios";

export default {
  components: {
    BAvatar,
    BLink,
    BCard,
    BRow,
    BCol,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BButton,
    BCardFooter,
    BOverlay,
  },
  data() {
    return {
      selectedPaymentOptionId: 0,
      selectedPaymentOption: "",
      traceNumber: "678da649-a57a-4105-9f8c-5b573eebae5c_CodeEP2506672581711",
      paymentOptions: [],
      customerData: {
        orderId: "",
        firstName: "",
        lastName: "",
        ammount: "",
        currency: "",
        isLoading: false,
      },
      requetFormData: {
        traceNumbers: "",
        paymentOptionsId: 0,
      },
      paymentOptionName: "",
      orderId: "",
      expiryDate: "",
      returnedAmount: null,
      isLoading: false,
      toogle: false,
      instructions: [],
      accessToken: null,
    };
  },
  created() {
    // this.getClientToken()
    // this.fetchData()
    this.fetchDataGate();
  },
  methods: {
    handelSelect(item) {
      this.selectedPaymentOptionId = null;
      this.paymentOptions.forEach((res) => {
        if (item.id === res.id) {
          //   res.bg = 'primary'
          res.bv = "success";
          res.visible = true;
          this.selectedPaymentOptionId = item.id;
          this.selectedPaymentOption = item.name;
        } else {
          res.bv = "light";
          res.visible = false;
        }
      });
    },
    getClientToken() {
      // Simple POST request with a JSON body using fetch
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // username: "PortalAdmin@ethiopianairlines.com",
          // password: "Abcd@1234",
          serviceKey:process.env.VUE_APP_BASE_KEY,
        }),
      };
      // fetch('https://ethiopiangatewaytest.azurewebsites.net/api/V1.0/Token/GetToken ', requestOptions)
      fetch(
        "https://flygateapiqualityprod.azurewebsites.net/api/V1.0/Token/GetToken ",
        requestOptions
      ).then((response) => {
        const res = response.json();
        console.log(res);
        this.accessToken = response.accessToken;
      });
    },
    fetchDataGate() {
      const traceNumberRoute = this.$route.fullPath
        .substring(this.$route.fullPath.lastIndexOf("?"))
        .substring(1);
      this.traceNumber = traceNumberRoute;
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Orders-GetOrderPayByLink"
      );

      axios
        .post("/api/V1.0/Token/GetToken", {
          // username: "PortalAdmin@ethiopianairlines.com",
          serviceKey:process.env.VUE_APP_BASE_KEY,
          // username: 'ePassportMerchantProd@ethiopianairlines.com',
          // password: 'EPassAdmin#Code89654',
        })
        .then((response) => {
          useJwt.setToken(response.accessToken);

          axios
            .get(
              `/Order/api/V1.0/Orders/GetOrderPayByLink?traceNumber=${this.traceNumber}`
            )
            .then((res) => {
              res.paymentOptions.forEach((item) => {
                this.paymentOptions.push({
                  id: item.id,
                  name: item.name,
                  logo: item.imageUrl,
                });
              });
              this.isLoading = false;
              this.customerData.orderId = res.orderId;
              this.customerData.firstName = res.firstName;
              this.customerData.lastName = res.lastName;
              this.customerData.ammount = res.amount;
              this.customerData.currency = res.currency;
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
            });
        })
        .catch((error) => {
          console.log(`Error msg: ${error}`);
          // this.$refs.loginForm.setErrors(error)
        });
    },
    SubmitData() {
      // eslint-disable-next-line no-alert

      if (this.selectedPaymentOptionId === 0) {
        this.$bvModal.msgBoxOk("Please Select Payment Option", {
          title: "Error",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        });
      } else {
        this.$store.dispatch("config/getActionPrivilege", "Account-View");
        this.isLoading = true;

        this.requetFormData.paymentOptionsId = this.selectedPaymentOptionId;
        this.requetFormData.traceNumbers = this.traceNumber;
        axios
          .post(
            "/Order/api/V1.0/Orders/SubmitOrderPayByLink",
            this.requetFormData
          )
          .then((res) => {
            this.isLoading = false;
            // this.fetchData()
            console.log(res);
            console.log(res.instractions);

            this.$bvModal.msgBoxOk(`${res.message}`, {
              title: "Success",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
            this.toogle = true;
            this.instructions = res.instractions;
            this.paymentOptionName = res.paymentOptionName;
            this.orderId = res.orderId;
            this.expiryDate = res.expiryDate;
            this.returnedAmount = res.amount;

            document.getElementById("paymentsDiv").innerHTML = "";

            // this.$router.push({ name: 'instruction-fop', query: { id: this.requetFormData.paymentOptionsId } })
            // this.router.push({ path: '/orders/Instructions', query: { id: this.requetFormData.paymentOptionsId } })

            //  this.$router.push({ name: 'instruction-fop', query: { id: 9, name: 'PaymentOption' } })
          })
          .catch((res) => {
            console.log(res);
            this.isLoading = false;
            this.$bvModal.msgBoxOk(res.data.message, {
              title: "Error",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          });

        // eslint-disable-next-line no-alert
        // alert(`form submitted! ${this.customerData.orderId} ${this.selectedPaymentOptionId}`)
      }
    },
    fetchData() {
      fetch(
        `/Order/api/V1.0/Orders/GetOrderPayByLink?traceNumber=${this.traceNumber}`,
        {
          method: "GET",
          headers: {
            ActionPrivilegies: "Orders-GetOrderPayByLink",
            Authorization: `Bearer ${this.apiKey}`,
          },
        }
      )
        .then((res) => {
          const response = res.json();
          response.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              id: item.id,
              name: item.name,
              logo: item.imageUrl,
            });
          });
          this.isLoading = false;
          this.customerData.orderId = res.orderId;
          this.customerData.firstName = res.firstName;
          this.customerData.lastName = res.lastName;
          this.customerData.ammount = res.amount;
          this.customerData.currency = res.currency;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
